import React from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureFlag, useFeatureFlag } from '../../utils/featureFlags';

interface FeatureFlagOverlayProps {
  feature: FeatureFlag;
  children: React.ReactNode;
}

const FeatureFlagOverlay: React.FC<FeatureFlagOverlayProps> = ({ feature, children }) => {
  const { t } = useTranslation();
  const isFeatureEnabled = useFeatureFlag(feature);

  return (
    <div className="relative">
      {!isFeatureEnabled && (
        <div className="absolute inset-0 bg-gray-800 bg-opacity-20 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-sm shadow-lg">
            <p className="text-lg font-medium">{t('common.feature_not_enabled')}</p>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default FeatureFlagOverlay;
